import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  Outlet,
} from "react-router-dom";
import './index.scss';
import ScrollToTop from './components/ScrollToTop';
import Seo from './components/Seo';
import Home from './module/Home'
import ZKAttestation from './module/ZKAttestation';
import Blog from './module/Blog';
import AttestationProcessor from './module/AttestationProcessor';
import Ecosystem from "./module/Ecosystem";
import PoR from "./module/PoR";
import NotFound from "./module/NotFound";
import reportWebVitals from './reportWebVitals';

// Scroll to top on page initialization
window.scrollTo(0, 0);

const root = ReactDOM.createRoot(document.getElementById('root'));

function RootLayout() {
  return (
    <>
      <ScrollToTop />
      <Seo />
      <Outlet />
    </>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "data-verification",
        element: <ZKAttestation />,
      },
      {
        path: "dataVerification",
        element: <Navigate to="/data-verification" replace />,
      },
      {
        path: "blog",
        element: <Blog />,
      },
      {
        path: "attestation-processor",
        element: <AttestationProcessor />,
      },
      {
        path: "ecosystem",
        element: <Ecosystem />,
      },
      {
        path: "por",
        element: <PoR />,
      },
      {
        path: "*",
        element: <NotFound />,
        handle: { notFound: true },
      },
    ],
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
